<template>
  <div class="share">
    <div class="topBar">
      <div class="topBar-left"></div>
      <span class="topBar-middle">闲至优品</span>
      <div class="topBar-right">下载</div>
    </div>
    <div class="head">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item, index) in goodData.images" :key="index">
          <img :src="imgPrefix + item" class="swipeImage" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="middle">
      <h2>{{ goodData.name }}</h2>
      <p>{{ goodData.subTitle }}</p>
      <div class="price">
        <p>
          <span><i>现价</i>￥{{ goodData.salesPrice }}</span>
          <span><i>全新</i><b>￥{{ goodData.originalPrice }}</b></span>
        </p>
      </div>
      <div class="otherService">
        <div class="label" v-for="(item, index) in goodData.labelList" :key="index">
          {{ item.name }}
        </div>
      </div>
      <div class="container">
        <p>
          <span>运费：{{ goodData.freightAmount }}元</span>
          <span>销量：{{ goodData.salesQuantity }}</span>
        </p>
      </div>

      <div class="gift-wrapper" v-if="this.goodData.giftList">
        <span>赠品：</span>
        <div class="gift-box">
          <div class="gift-label" v-for="(item, index) in goodData.giftList" :key="index">
            <img :src="imgPrefix + item.image" alt="" />
            <span>{{ item.name }}</span>
          </div>
        </div>
      </div>
      <div class="wrapper" v-if="this.coupon.length != 0">
        <span>领劵：</span>
        <div class="w-box">
          <div class="w-label" v-for="(item, index) in coupon" :key="index">
            满{{ item.usingCondition }}减{{ item.discount }}
          </div>
        </div>
      </div>
      <div class="specification">
        <van-field name="radio" :label="item.name" v-for="(item, index) in this.specificationList" :key="index">
          <template #input>
            <van-radio-group v-model="radioArray[index]" class="colour" @change="onChangeColour(index)">
              <van-radio checked-color="#ee0a24" :name="items.id" v-for="items in item.valueList" :key="items.id" @change="handleRadioChanges(index, items.id)">{{ items.textValue }}</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </div>
      <div class="goodnum">
        <span>数量：</span>
        <div class="w-box">
          <van-stepper v-model="value" />
        </div>
      </div>
      <div class="wrapper">
        <span>支付方式：</span>
        <span>微信/支付宝</span>
      </div>
      <div class="report" v-if="this.QcReportData">
        <h2>闲至优品</h2>
        <h3>{{ QcReportData.name }}</h3>
        <van-divider />
        <div class="report_inspector">
          <img :src="imgPrefix + QcReportData.inspectorAvatar" alt="" />
          <div>
            <p>{{ QcReportData.inspectorName }}</p>
            <p>{{ QcReportData.inspectorLevel }}</p>
          </div>
          <img src="../assets/a3_hege.png" alt="" />
        </div>
        <div class="result">
          <div class="result-head">检查结果</div>
          <p>{{ QcReportData.content }}</p>
          <van-divider />
          <van-collapse v-model="activeNames" accordion>
            <van-collapse-item name="1">
              <template #title>
                <div class="vantItem">
                  检查功能<span>
                    <van-icon name="checked" />全通过
                  </span>
                </div>
              </template>
              <div class="sectorization">
                <span v-for="(item, index) in QcReportData.functionalEvaluation" :key="index">
                  {{ item }}
                </span>
                <p>官方自营 | 七天包退换 | 180天质保</p>
              </div>
            </van-collapse-item>
          </van-collapse>
        </div>
      </div>
    </div>
    <div class="floor" v-html="goodData.description"></div>
    <van-goods-action>
      <van-goods-action-icon icon="chat-o" text="客服" color="#ee0a24" @click="download" />
      <van-goods-action-icon icon="cart-o" text="购物车" @click="download" />
      <van-goods-action-icon icon="star" text="收藏" color="#000" @click="download" />
      <van-goods-action-button type="warning" text="加入购物车" @click="download" />
      <van-goods-action-button type="danger" text="立即购买" @click="download" />
    </van-goods-action>

  </div>
</template>

<script>
export default {
  data() {
    return {
      goodData: {},
      coupon: [],
      value: "1",
      imgPrefix: "http://qiniu.xzypapp.com/",
      speArr: [], //规格数组
      QcReportData: "",
      activeNames: ["1"],
      specificationList: [],
      radioArray: [],
      ruleForm: {},
    };
  },
  components: {},
  methods: {
    get(id) {
      this.axios({
        method: "post",
        url: "api/product/get",
        data: {
          id: id,
        },
      }).then((res) => {
        this.goodData = res.data.data
        if (this.goodData.giftList.length ==0) {
           delete this.goodData.giftList
        }
        this.goodData.images = this.goodData.images.split("|");
      });
    },
    getcoupon(id) {
      this.axios({
        method: "post",
        url: "api/coupon/findByMultipleId",
        data: {
          goodsId: id,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          this.coupon = res.data.data;
        }
      });
    },
    getSpecification(id) {
      this.axios({
        method: "post",
        url: "api/param/findByProductId",
        data: {
          productId: id,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          let data = res.data.data;
          this.specificationList = res.data.data
          if (this.specificationList) {
            this.specificationList.forEach((e, index) => {
              this.radioArray[index] = e.valueList[0].id;
            });
          }
          this.speArr = data.map((e, i) => {
            return e.valueList[0].id;
          });
          this.getQcReport(id, this.speArr);
        }
      });
    },
    getQcReport(id, speArr) {
      this.axios({
        method: "post",
        url: "api/goods/findByValueIdList",
        data: {
          productId: id,
          valueIdList: speArr,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          this.goodData.salesPrice = res.data.data.salesPrice
          if (res.data.data.report) {
            this.QcReportData = res.data.data.report;
            this.QcReportData.functionalEvaluation = this.QcReportData.functionalEvaluation.split("|");
          }
        }
      });
    },
    download() {
      this.$router.push({
        name: "download",
      });
    },
    // 选择规格后的事件
    onChangeColour(val) {
      console.log(this.radioArray);
      this.getQcReport(this.$route.query.id, this.radioArray);
    },
    handleRadioChanges(index, strnum) {
      console.log(this.radioArray);
    },
  },
  mounted() {
    console.log(this.$route);
    let id = this.$route.query.id;
    let skuId = this.$route.query.skuId;
    this.get(id);
    this.getcoupon(skuId);
    this.getSpecification(id);
  },
};
</script>


<style lang="less" scoped>
@import "../assets/rebate.less";
</style>


// WEBPACK FOOTER //
// src/components/share.vue